import { Link } from "react-router-dom";
import { trackFooterLinkClick } from "@/utils/eventTracking";
export function Footer() {
  return (
    <footer className="bg-gray-800 text-gray-300 py-8">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-lg font-semibold mb-4">Instavault</h3>
            <p className="text-sm">
              Transform your all social saves into knowledge digests.
            </p>
          </div>
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="https://www.instavault.co/#features" // Use "to" instead of "href"
                  className="hover:text-white text-gray-400 transition-colors"
                  onClick={() => trackFooterLinkClick('Features', 'https://www.instavault.co/#features')}
                >
                  Features
                </Link>
              </li>
              <li>
                <Link
                  to="https://www.instavault.co/#how-it-works" // Use "to" instead of "href"
                  className="hover:text-white text-gray-400 transition-colors"
                  onClick={() => trackFooterLinkClick('How It Works', 'https://www.instavault.co/#how-it-works')}
                >
                  How It Works
                </Link>
              </li>
              <li>
                <Link
                  to="https://www.instavault.co/#pricing" // Use "to" instead of "href"
                  className="hover:text-white text-gray-400 transition-colors"
                  onClick={() => trackFooterLinkClick('Pricing', 'https://www.instavault.co/#pricing')}
                >
                  Pricing
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="text-lg font-semibold mb-4">Legal</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="https://www.instavault.co/terms" // Use "to" instead of "href"
                  className="hover:text-white text-gray-400 transition-colors"
                  onClick={() => trackFooterLinkClick('Terms of Service', 'https://www.instavault.co/terms')}
                >
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link
                  to="https://www.instavault.co/privacy" // Use "to" instead of "href"
                  className="hover:text-white text-gray-400 transition-colors"
                  onClick={() => trackFooterLinkClick('Privacy Policy', 'https://www.instavault.co/privacy')}
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="https://www.instavault.co/support" // Use "to" instead of "href"
                  className="hover:text-white text-gray-400 transition-colors"
                  onClick={() => trackFooterLinkClick('Support', 'https://www.instavault.co/support')}
                >
                  Support
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-8 pt-8 border-t border-gray-700 text-center text-sm">
          <p>&copy; 2025 Instavault. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
